import { createFileRoute } from "@tanstack/react-router";
import { getCity } from "@/lib/seo/cities";
import { videoproduktionForCity } from "@/lib/seo/cityHubCopy";
import { cityHubRoute } from "@/lib/seo/cityHubRoute";

const city = getCity("orebro")!;
const page = videoproduktionForCity(city);

export const Route = createFileRoute("/videoproduktion_/orebro")(cityHubRoute(city, page));
